var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFloppyDiskIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6667 3.23513e-06H3.94267C3.58877 -0.000778523 3.24929 0.140151 3 0.391337L0.390667 3C0.140994 3.25053 0.000555169 3.58964 0 3.94334V14.6667C0 15.4031 0.596954 16 1.33333 16H14.6667C15.403 16 16 15.4031 16 14.6667V1.33334C16 0.596957 15.403 3.23513e-06 14.6667 3.23513e-06ZM12.3333 1.33334C12.5174 1.33334 12.6667 1.48258 12.6667 1.66667V4.33334C12.6667 4.88562 12.219 5.33334 11.6667 5.33334H5C4.44772 5.33334 4 4.88562 4 4.33334V1.66667C4 1.48258 4.14924 1.33334 4.33333 1.33334H12.3333ZM3 14.3333C3 14.5174 3.14924 14.6667 3.33333 14.6667H13.3333C13.5174 14.6667 13.6667 14.5174 13.6667 14.3333V9C13.6667 8.44772 13.219 8 12.6667 8H4C3.44772 8 3 8.44772 3 9V14.3333Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.83398V3.83398C10 4.11013 10.2239 4.33398 10.5 4.33398C10.7761 4.33398 11 4.11013 11 3.83398V2.83398C11 2.55784 10.7761 2.33398 10.5 2.33398C10.2239 2.33398 10 2.55784 10 2.83398Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66699 10.834H9.00033C9.27647 10.834 9.50033 10.6101 9.50033 10.334C9.50033 10.0578 9.27647 9.83398 9.00033 9.83398H4.66699C4.39085 9.83398 4.16699 10.0578 4.16699 10.334C4.16699 10.6101 4.39085 10.834 4.66699 10.834Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66699 13.5007H12.0003C12.2765 13.5007 12.5003 13.2768 12.5003 13.0007C12.5003 12.7245 12.2765 12.5007 12.0003 12.5007H4.66699C4.39085 12.5007 4.16699 12.7245 4.16699 13.0007C4.16699 13.2768 4.39085 13.5007 4.66699 13.5007Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloppyDiskIcon);
export default __webpack_public_path__ + "static/media/floppy-disk-icon.cadf9c97ed6a42f47996cde583b2a863.svg";
export { ForwardRef as ReactComponent };